<script>
import ThreeMixin from "../Three.vue";
import {
  Mesh,
  Color,
  TorusGeometry,
  PlaneGeometry,
  MeshBasicMaterial,
  DoubleSide,
} from "three";
import FunctionSurface from "../FunctionSurface.js";
import Animation from "../Animation.vue";
import OnDrumData from "../../assets/examples/on_drum_5.json";

export default {
  mixins: [ThreeMixin, Animation],
  created() {
    this.$on("tick", this.animationFrame.bind(this));

    this.renderer.setClearColor(new Color("white"));

    this.camera.fov = 30;
    this.camera.updateProjectionMatrix();

    const mx = 1.2;
    const my = 0.6;

    this.xz = new Mesh(
      new PlaneGeometry(2 * mx, 2 * mx),
      new MeshBasicMaterial({ color: 0x999999, side: DoubleSide })
    );
    this.xz.rotateX(Math.PI / 2);
    this.xz.position.set(0, -my, 0);
    this.scene.add(this.xz);

    this.yz = new Mesh(
      new PlaneGeometry(2 * mx, 2 * my),
      new MeshBasicMaterial({ color: 0x777777, side: DoubleSide })
    );
    this.yz.rotateY(Math.PI / 2);
    this.yz.position.set(-mx, 0, 0);
    this.scene.add(this.yz);

    this.xy = new Mesh(
      new PlaneGeometry(2 * mx, 2 * my),
      new MeshBasicMaterial({ color: 0xbbbbbb, side: DoubleSide })
    );
    this.xy.position.set(0, 0, -mx);
    this.scene.add(this.xy);

    this.functionSurface = new FunctionSurface(OnDrumData);
    this.functionSurface.disc = true;
    this.functionSurface.progress = 1;
    this.functionSurface.scale.set(1, 0.5, 1);
    this.scene.add(this.functionSurface);

    const torus = new Mesh(
      new TorusGeometry(1, 0.015, 8, 60),
      new MeshBasicMaterial({ color: 0x666666 })
    );
    torus.rotateX(Math.PI / 2);

    this.scene.add(torus);
  },
  mounted() {
    this.startAnimation();
  },
  methods: {
    animationFrame() {
      const t =
        (-5 + (20 * (1 + Math.sin(this.time / 3000))) / 2) / (180 / Math.PI);
      const r = 4.3;
      const lx = -0.1,
        ly = 0,
        lz = -0.25;
      this.camera.position.set(
        lx + r * Math.sin(t),
        lz + r * Math.sin((Math.PI / 180) * 10 + t),
        ly + r * Math.cos(t)
      );
      this.camera.lookAt(lx, lz, ly);
      this.render();
    },
  },
};
</script>